"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var util_1 = require("./util");
/**
 * Render the first `When` child whose`test` prop evaluates to true.
 */
function Switch(_a) {
    var children = _a.children;
    var choice;
    React.Children.forEach(children, function (child) {
        if (choice === void 0 &&
            React.isValidElement(child) &&
            child.type._isWhen &&
            util_1.toBoolean(child.props.test)) {
            choice = child;
        }
    });
    return util_1.toElement(choice ? choice.props.render : null);
}
exports.Switch = Switch;
function When(_) {
    return null;
}
exports.When = When;
When._isWhen = true;
When.propTypes = {
    test: PropTypes.any,
    render: PropTypes.any.isRequired
};
//# sourceMappingURL=switch-when.js.map